// import * as Sentry from '@sentry/react-native';

import { JAVA_BASE_URL, NODE_BASE_URL } from "utils/Constants";
import { name as packageName, version } from "../../package.json";

import AsyncStorage from "@react-native-async-storage/async-storage";
import DeviceInfo from "react-native-device-info";
import { Platform } from "react-native";
import axios from "axios";
import { getTimeZone } from "react-native-localize";
import { isInternetConnected } from "utils/checkInternet";

// import { track } from "utils/Segment";

const axiosJavaInstance = axios.create({
  baseURL: JAVA_BASE_URL,
  timeout: 120000,
});

const axiosNodeInstance = axios.create({
  baseURL: `${NODE_BASE_URL}api`,
  timeout: 120000,
});

const getIpAddress = async () => {
  const ip = await AsyncStorage.getItem("ip");
  const reserveIp = await AsyncStorage.getItem("reseveIP");
  const ipSetTime = await AsyncStorage.getItem("ipSetTime");
  const currentTime = new Date().getTime();

  if (!ip || !ipSetTime || currentTime - parseInt(ipSetTime, 10) > 60 * 60000) {
    // 60000 ms = 1 minute
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      const data = await response.json();
      if (reserveIp != data.ip) {
        await AsyncStorage.setItem("IPisChanged", "true");
      }

      await AsyncStorage.setItem("ip", data.ip);
      await AsyncStorage.setItem("reseveIP", data.ip);
      await AsyncStorage.setItem("ipSetTime", currentTime.toString());
      return data.ip;
    } catch (err) {
      console.error("Failed to fetch IP:", err);
    }
  }
  return ip;
};

const getCountry = async () => {
  const country = await AsyncStorage.getItem("country");
  if (country) {
    return country;
  }
  return "United States of America";
};

const getCurrency = async () => {
  const currency = await AsyncStorage.getItem("currency");
  if (currency) {
    return currency.split(" ")[0];
  }
  return "USD";
};

const getGender = async () => {
  const gender = await AsyncStorage.getItem("gender");
  // console.log('API',gender,await AsyncStorage.getAllKeys())
  if (gender) {
    return gender;
  }
  return "female";
};

axiosJavaInstance.interceptors.request.use(
  async (config) => {
    config.headers["Content-Type"] = "application/json";
    config.headers["appversion"] = DeviceInfo.getVersion();
    config.headers["systemVersion"] = DeviceInfo.getSystemVersion();
    config.headers["buildNumber"] = DeviceInfo.getBuildNumber();
    config.headers["timeZone"] = getTimeZone();
    config.headers["Brand"] = Platform?.constants?.Brand || "";
    config.headers["Model"] = Platform?.constants?.Model || "";
    config.headers["Version"] = Platform.Version;
    config.headers["deviceType"] = Platform.OS;
    config.headers["devicetype"] = Platform.OS;
    config.headers["User-details"] =
      packageName + "/" + Platform.OS + "/" + version;
    config.headers["ip"] = await getIpAddress();
    config.headers["country"] = await getCountry();
    config.headers["currency"] = await getCurrency();
    config.headers["gender"] = await getGender()

    try {
      let token = await AsyncStorage.getItem("token");
      if (token) {
        config.headers["token"] = "token";
      }
      let persist = await AsyncStorage.getItem("persist:root");
      const userId = JSON.parse(JSON.parse(persist)?.AuthReducer)?.userId;
      const guestUserId = JSON.parse(
        JSON.parse(persist)?.StoredutilsSlice
      )?.guestUserId;
      if (persist && userId) {
        config.headers["USER-ID"] = userId;
        config.headers["userId"] = userId;
      } else if (persist && guestUserId) {
        config.headers["USER-ID"] = guestUserId;
        config.headers["userId"] = guestUserId;
      } else {
        config.headers["USER-ID"] = 0;
        config.headers["userId"] = 0;
      }
    } catch (err) {
      console.log("err", err);
    }

    return config;
  },
  (error) => {
    console.error("Error while setting up axios request interceptor,", error);
  }
);

axiosJavaInstance.interceptors.response.use(undefined, async (err) => {
  let originalRequest = err.config;
  const networkConnection = await isInternetConnected();
  if (
    (originalRequest?.retryCount == undefined ||
      originalRequest?.retryCount < 3) &&
    err?.response?.status >= 500
  ) {
    console.log("API ERROR, Retrying...", originalRequest?.url);
    if (networkConnection) {
      originalRequest.retryCount = originalRequest.retryCount
        ? originalRequest.retryCount + 1
        : 1;
      return axiosJavaInstance(originalRequest);
    }
  } else {
    return Promise.reject(err);
  }
});

axiosNodeInstance.interceptors.request.use(
  async (config) => {
    config.headers["Content-Type"] = "application/json";
    config.headers["appversion"] = DeviceInfo.getVersion();
    config.headers["systemVersion"] = DeviceInfo.getSystemVersion();
    config.headers["buildNumber"] = DeviceInfo.getBuildNumber();
    config.headers["timeZone"] = getTimeZone();
    config.headers["Brand"] = Platform?.constants?.Brand || "";
    config.headers["Model"] = Platform?.constants?.Model || "";
    config.headers["Version"] = Platform.Version;
    config.headers["deviceType"] = Platform.OS;
    config.headers["devicetype"] = Platform.OS;
    config.headers["User-details"] =
      packageName + "/" + Platform.OS + "/" + version;
    config.headers["ip"] = await getIpAddress();
    config.headers["country"] = await getCountry();
    config.headers["currency"] = await getCurrency();
    config.headers["gender"] = await getGender()

    try {
      let token = await AsyncStorage.getItem("token");
      if (token) {
        config.headers["token"] = "token";
      }
      let persist = await AsyncStorage.getItem("persist:root");
      const userId = JSON.parse(JSON.parse(persist)?.AuthReducer)?.userId;
      const guestUserId = JSON.parse(
        JSON.parse(persist)?.StoredutilsSlice
      )?.guestUserId;
      if (persist && userId) {
        config.headers["USER-ID"] = userId;
        config.headers["userId"] = userId;
      } else if (persist && guestUserId) {
        config.headers["USER-ID"] = guestUserId;
        config.headers["userId"] = guestUserId;
      } else {
        config.headers["USER-ID"] = 0;
        config.headers["userId"] = 0;
      }
    } catch (err) {
      console.log("err", err);
    }

    return config;
  },
  (error) => {
    console.error("Error while setting up axios request interceptor,", error);
  }
);

axiosNodeInstance.interceptors.response.use(undefined, async (err) => {
  let originalRequest = err.config;
  const networkConnection = await isInternetConnected();
  if (
    (originalRequest?.retryCount == undefined ||
      originalRequest?.retryCount < 3) &&
    err?.response?.status >= 500
  ) {
    console.log("API ERROR, Retrying...", originalRequest?.url);
    if (networkConnection) {
      originalRequest.retryCount = originalRequest.retryCount
        ? originalRequest.retryCount + 1
        : 1;
      return axiosJavaInstance(originalRequest);
    }
  } else {
    return Promise.reject(err);
  }
});

export const APIV2 = async (
  url,
  method = "GET",
  data = null,
  baseUrlType = "NODE",
  abortSignal,
  dynamicHeaders = null
) => {
  return new Promise(async (resolve, reject) => {
    let options = {
      method,
      url,
      signal: abortSignal,
    };
    if (dynamicHeaders) {
      options.headers = dynamicHeaders;
    }

    const networkConnection = await isInternetConnected();

    if (["POST", "DELETE"].includes(method) && data) {
      options.data = data;
    }

    if (!networkConnection) {
      return new Error("No internet connection available.");
    }
    if (baseUrlType == "NODE") {
      axiosNodeInstance(options)
        .then((res) => {
          if (process.env.EXPO_PUBLIC_ENV == "STAGING") {
            // track("API_EVENT", { options, res: res?.data });
          }
          resolve(res);
        })
        .catch(reject);
    } else {
      axiosJavaInstance(options)
        .then((res) => {
          if (process.env.EXPO_PUBLIC_ENV == "STAGING") {
            // track("API_EVENT", { options, res: res?.data });
          }
          resolve(res);
        })
        .catch(reject);
    }
  }).catch((err) => {
    // Sentry.captureException(err, 'Dispatch err');
    return Promise.reject(err);
  });
};
